import { Trans } from 'react-i18next';

export const SuccessMessage = ({ bookingLegacyId, email }: { bookingLegacyId?: number; email?: string }) => {
  return (
    <>
      {bookingLegacyId && (
        <p>
          <Trans i18nKey='offers:printText' components={{ b: <b /> }} values={{ bookingLegacyId }}></Trans>
        </p>
      )}
      {email && (
        <p>
          <Trans i18nKey='offers:processEmailSuccessDescription' components={{ b: <b /> }} values={{ email }}></Trans>
        </p>
      )}
    </>
  );
};
